module.exports = __webpack_public_path__ + "img/conference_call.b795b110.svg";